import {CheckboxFormComponent} from '../components/checkbox-form/checkbox-form.component';
import {CustomFieldComponent} from '../components/custom-component/custom-component.component';
import {DateFormComponent} from '../components/date-form/date-form.component';
import {IbanFormComponent} from '../components/iban-form/iban-form.component';
import {InputFormComponent} from '../components/input-form/input-form.component';
import {NotificationBoxComponent} from '../components/notification-box/notification-box.component';
import {PrivacyCheckboxFormComponent} from '../components/privacy-checkbox-form/privacy-checkbox-form.component';
import {RadioComponent} from '../components/radio/radio.component';
import {SelectFormComponent} from '../components/select-form/select-form.component';
import {SwitcherFormComponent} from '../components/switcher-form/switcher-form.component';
import {TextAreaComponent} from '../components/text-area/text-area.component';
import {TextBoxComponent} from '../components/text-box/text-box.component';
import {TitleFormComponent} from '../components/title-form/title-form.component';
import {ToggleButtonComponent} from '../components/toggle-button/toggle-button.component';
import {UploadFileFormComponent} from '../components/upload-file-form/upload-file-form.component';
import {FieldType} from '../enums/field-type';
import {FieldsComponents} from '../interfaces/fields-components';

export const fieldTypeComponents: FieldsComponents = {
  [FieldType.CHECKBOX]: CheckboxFormComponent,
  [FieldType.DATE]: DateFormComponent,
  [FieldType.IBAN]: IbanFormComponent,
  [FieldType.INPUT]: InputFormComponent,
  [FieldType.NOTIFICATION_BOX]: NotificationBoxComponent,
  [FieldType.FILE_UPLOAD]: UploadFileFormComponent,
  [FieldType.PRIVACY]: PrivacyCheckboxFormComponent,
  [FieldType.RADIO]: RadioComponent,
  [FieldType.TOGGLE_BUTTON]: ToggleButtonComponent,
  [FieldType.SELECT]: SelectFormComponent,
  [FieldType.SWITCHER]: SwitcherFormComponent,
  [FieldType.TEXT_AREA]: TextAreaComponent,
  [FieldType.TEXT_BOX]: TextBoxComponent,
  [FieldType.TITLE]: TitleFormComponent,
  [FieldType.CUSTOM]: CustomFieldComponent,
};
